$(document).ready(function(){
  $("body").on("click","[data-starpost]:not(.stars--rated) div",function(){
    parent = $(this).closest('[data-starpost]');
    $.post("/module/postrate",{
      "post_id": $(this).closest("[data-starpost]").attr("data-starpost"),
      "rate": $(this).attr('data-value'),
      "_token": window.Laravel.csrfToken
    },function(response){
      $('.stars__item--active').removeClass('stars__item--active');
      if(response.rate>0) {
        for(var i=1;i<=4;i++){
          if(response.rate>=i) {
            $('[data-starpost] [data-value="'+i+'"]').addClass('stars__item--active');
          }
        }
        if(response.rate==5) {
          $('[data-starpost] [data-value="5"]').addClass('stars__item--active');
        }
      }

      $('.stars__tooltip').fadeIn().addClass('tooltipShowed').addClass('rated');
      setTimeout(function(){
        $('.stars__tooltip').fadeOut();
      }, 3000);


      if ( $('.tooltipShowed').length ) {
        $('.stars__tooltip').delay(2000).fadeOut().addClass('tooltipShowed');
      }

      $("[data-rate-value]").html(parseFloat(response.rate).toFixed(1));
      $("[data-rate-counter]").html(response.counter);

      if(response.code == 1){
        $('.stars__tooltip').text('Dziękujemy za ocenę');
      }else{
        $('.stars__tooltip').text('Już oceniłeś ten wpis');
      }

    });
  });

  if ($('.stars__item--active').length) {
    $('.stars').addClass('stars--inactive');
  }



});
